import { getApiClient } from '../../api';
import { Message } from 'primereact/message';
import { Messages } from 'primereact/messages';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '../../components/LoadingPage';
import { getErrorMessage } from '../../utils/errors';
import { ErrorMessage } from '../components/ErrorMessage';
import { MunicipalityForm } from '../components/MunicipalityForm';
import { showErrorMessage } from '../utils/messages';
import { scrollTop } from '../utils/scroll';

export default function RequestNewMunicipalityAdd() {
    const navigate = useNavigate();

    const msgs = useRef(null);

    const [loading, setLoading] = useState(true);
    const [initError, setInitError] = useState(null);
    const [municipalityTypeOptions, setMunicipalityTypeOptions] = useState([]);
    const [bodyTypeOptions, setBodyTypeOptions] = useState([]);

    useEffect(() => {
        const loadMunicipalityTypes = async () => {
            const municipalityTypesResponse = await getApiClient().getAdminMunicipalityType();
            setMunicipalityTypeOptions(
                municipalityTypesResponse.map((typMunicipality) => ({
                    label: typMunicipality.code,
                    value: typMunicipality.id
                }))
            );
        };

        const loadBodyTypes = async () => {
            const bodyTypesResponse = await getApiClient().getAdminBodyType();
            setBodyTypeOptions(
                bodyTypesResponse.map((typOrganu) => ({
                    label: typOrganu.code,
                    value: typOrganu.id,
                    text_value: typOrganu.code
                }))
            );
        };

        const fetchData = async () => {
            try {
                await Promise.all([loadMunicipalityTypes(), loadBodyTypes()]);
            } catch (error) {
                const errorMessage = getErrorMessage(error);
                setInitError(errorMessage ?? 'Nepodařilo se načíst typy municipalit nebo orgánů');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const onSubmit = async (data) => {
        const requestData = {
            text: data.text,
            text_id: data.text_id,
            municipality_type: data.municipality_type,
            name: data.name,
            name_genitive: data.name_genitive,
            color: data.color,
            url: data.url,
            email: data.email ? data.email : null,
            body_type: data.body_type,
            zastupitelstvo_application_name: data.zastupitelstvo_application_name,
            zastupitelstvo_name: data.zastupitelstvo_name,
            zastupitelstvo_name_genitive: data.zastupitelstvo_name_genitive,
            zastupitelstvo_place: data.zastupitelstvo_place,
            zastupitelstvo_member_count: data.zastupitelstvo_member_count,
            zastupitelstvo_application_description: data.zastupitelstvo_application_description
        };
        try {
            await getApiClient().postAdminAddMunicipality(requestData);
            navigate(`/admin/municipality/`);
        } catch (error) {
            const errorMessage = getErrorMessage(error);
            showErrorMessage(msgs, errorMessage ?? 'Nepodařilo se vytvořit žádost', { replace: true });
            scrollTop();
        }
    };

    return loading ? (
        <LoadingPage />
    ) : (
        <>
            <h1>Podat žádost o přidání nové municipality</h1>

            {initError ? (
                <ErrorMessage prefix='Nelze použít formulář' text={initError} />
            ) : (
                <>
                    <Messages ref={msgs} className='page__messages' />

                    <Message
                        severity='info'
                        className='mb-2'
                        text='Vyplňte formulář a odešlete žádost o přidání nové municipality.'
                    />

                    <MunicipalityForm
                        municipalityTypeOptions={municipalityTypeOptions}
                        bodyTypeOptions={bodyTypeOptions}
                        onSubmit={onSubmit}
                        request={true}
                    />
                </>
            )}
        </>
    );
}
